import * as Common from "../../commons/common"

export class SearchCondition {
  updated_at_from: string = ""
  updated_at_to: string = ""
  title: string = ""
  is_downloaded: string = ""
}

export class StudentFile{
  id: number
  title: string
  comment: string
  is_downloaded: boolean
  updated_at: string
  
  constructor(x: any){
    this.id = x.id;
    this.title = x.title;
    this.comment = x.comment;
    this.is_downloaded = x.is_downloaded;
    this.updated_at = Common.formatDate(x.updated_at, 'Y年M月D日 H:m:s');
  }
}